import * as utils from "../misc";

export function isinstock(prod) {
    if ((prod.is_in_stock && prod.is_purchasable) || (prod > 0 && jQuery("#product-" + prod).hasClass("instock"))) {
        return true;
    }
    else {
        return false;
    }
}

export function selldirect() {
    
    return jQuery(".productwheretobuy.btn").length > 0 ? false : true;
}


export function shownotificationform(prodid) {
    jQuery(".wheretobuyrow").hide();
    jQuery("#wheretobuyform").hide();
    jQuery(".woocommerce-variation-add-to-cart").removeClass("flex");
    jQuery(jQuery(".stocknotificationform").find("#input_8_7").val(prodid));
    var insertafter = (jQuery("form.cart").length > 0) ? "form.cart" : ".stock";
    jQuery(jQuery(".stocknotifywrapper")).insertAfter(insertafter);
    jQuery(jQuery(".stocknotifywrapper")).show();
}

export function get_selected_variation(varid) {

    let prodvars = jQuery(".variations_form").attr("data-product_variations");


    if (prodvars) {


        var variations = JSON.parse(prodvars);

        for (var a = 0; a < variations.length; a++) {
            var attributes = variations[a].attributes;
            var varimageid = variations[a].image_id;
            var found = true;
            var var_id = variations[a].variation_id;
            if (varid == var_id) {
                return variations[a];
            }
        }
    }
}

export function refresh_fragments(fragments) {

    if (fragments) {
        jQuery.each(fragments, function (key, value) {

            jQuery(key).replaceWith(value);
        });
    }

}

export function remove_from_cart(cart_item) {
    /*****REMOVE FROM SHOPPING CART */
    jQuery.post(base.ajaxurl, {
        action: "removefromcart",
        cart_item: cart_item
    }, function (r) {

        refresh_fragments(r.fragments)

    })
}

export function showbuyform(prodobj) {

    console.log("showbuyform: ", prodobj)
    jQuery(".wheretobuyrow").hide();
    jQuery("#wheretobuyform").hide();

    jQuery(".stocknotifywrapper").hide();
    jQuery(".isinstock").html("");
    if (!utils.isnull(prodobj)) {

        if (utils.isInt(prodobj) && prodobj <= 0) {
            return;
        }

        var prodid = prodobj.variation_id;
        var instock = isinstock(prodobj)
        var selld = selldirect();
        

        selld = (selld == "1") ? true : false; // sell direct from Store
        console.log("selld: ", selld);
        console.log("instock: ", instock);

        // if (selld) {
        //     //jQuery("#wheretobuyform").remove()
        // }
        // else {
        //     jQuery(".quantity").remove();
        //     jQuery("button[name='add-to-cart']").remove()
        // }

        if (instock <= 0 || !instock) {
            jQuery(".single_variation_wrap").hide();
            // jQuery(".quantity").remove();
            // jQuery("button[name='add-to-cart']").remove()
            // jQuery("button.single_add_to_cart_button").remove();
            shownotificationform(prodid)
        }
        else {
            jQuery(".single_variation_wrap").show();
            if (!jQuery(".productcontainer").children(".product").hasClass("product-type-simple")) {
                jQuery(".isinstock").html("<p class='stock in-stock'>In Stock</p>")
            }

            jQuery(".stocknotificationform").hide();
            if (!selld) {

                jQuery(".woocommerce-variation-add-to-cart").removeClass("flex");
                //  jQuery("#wheretobuyform").insertBefore(jQuery(".product_meta"));
                jQuery("#wheretobuyform").show();
                jQuery(".wheretobuyrow").show();
                jQuery(".stockistchecker").hide().slideUp();
                jQuery(".productwheretobuy").on("click", function () {
                    jQuery(".stockistchecker").slideDown();
                });
                jQuery(".productwheretobuy").show();
            }
            else {
                //in stock and sell direct
                jQuery(".woocommerce-variation-add-to-cart").show();
                jQuery(".woocommerce-add-to-cart").show();
            }
        }
    }
}